import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { useClientSpecificLogo } from '@hooks/clientSpecificUtils';
import { getClientSpecificIsLogoClickable } from '@helpers/clientSpecificUtils';
import { useMytaverse } from '@providers/MytaverseProvider';
import { APP_LOGO, IAppLogo } from './interfaces';
import { useStyles } from './styles';

const AppLogo = ({ to }: IAppLogo) => {
  const classes = useStyles();
  const { appTheme } = useMytaverse();
  const { logo, shouldStickToTheTop } = useClientSpecificLogo();

  const Logo =
    logo === APP_LOGO.ALT
      ? appTheme.customerAltLogo
      : appTheme.customerLogoFromAdmin ?? appTheme.customerLogo;

  // to check if a user is on login screen or not, we check if the user is authenticated
  // we can check this by looking at the state of user

  const LogoContent =
    typeof Logo === 'string' ? (
      <Box component="img" src={Logo} alt="Brand Logo" sx={classes.img} />
    ) : (
      Logo
    );

  if (to && getClientSpecificIsLogoClickable()) {
    return (
      <Box sx={classes.logoWrapper(shouldStickToTheTop)}>
        <Link
          style={{
            display: 'block',
            width: 'auto',
            height: 'auto',
            textDecoration: 'none',
          }}
          to={to}
        >
          {LogoContent}
        </Link>
      </Box>
    );
  }

  return <Box sx={classes.logoWrapper(shouldStickToTheTop)}>{LogoContent}</Box>;
};

export default AppLogo;
